export * from './src/privacy.component';
export * from './src/privacy-dialog.service';
